import { render } from "./CodeAuthorityPrivacy.vue?vue&type=template&id=fde32036"
import script from "./CodeAuthorityPrivacy.vue?vue&type=script&lang=js"
export * from "./CodeAuthorityPrivacy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__